import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 animate__animated animate__fadeInUp animate__faster right-0" }
const _hoisted_2 = { class: "relative flex flex-col-reverse w-full h-full items-end pr-4 pl-6 pb-2" }


    import Icon from '@/components/Icon/IndexIcon.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorBox',
  props: {
        bgColor: {
            type: String,
            default: 'red'
        },
        right: {
            type: String,
            default: '20'
        }
    },
  setup(__props) {

    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: _normalizeStyle({ 'background-color': __props.bgColor }),
        class: "flex-none rounded-full p-6 m-3 flex items-center justify-center cursor-pointer shadow-xl"
      }, [
        _createVNode(Icon, {
          size: "14",
          name: "close",
          color: "white"
        })
      ], 4)
    ])
  ]))
}
}

})